import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { IWandaTripInfo } from "../../../../types/TripTypes";
import { IDownloadPdfTrip } from "../../../../types/DownloadPdfTypes";

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    marginBottom: 10,
  },
  card: {
    border: "1px solid #D9D9D9",
    padding: 16,
    borderRadius: 10,
    marginBottom: 16,
  },
  normalText20: {
    fontSize: 20,
    fontWeight: 400,
    lineHeight: 1.4,
    fontFamily: "Helvetica",
  },
  boldText14: {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1.4,
    fontFamily: "Helvetica",
  },
  boldText16: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 1.4,
    fontFamily: "Helvetica",
    color: "#000000",
  },
  normalText16: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.4,
    fontFamily: "Helvetica",
  },
  normalText14: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.4,
    fontFamily: "Helvetica",
    color: "#7C878E",
  },
  legCostsAlign: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  overallCostAlign: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  solidDivider: {
    borderTop: "1px solid #D9D9D9",
    marginVertical: 8,
    marginBottom: 10,
  },
  costSeperationOrderDashed: {
    borderTop: "1px dashed #0063AF",
    marginVertical: 8,
  },
  tripDetailsContainer: {
    paddingLeft: 16,
  },
  tripCostTextColor: {
    color: "#389E0D",
  },
});

type prop = {
  trip: IDownloadPdfTrip;
  tripNo: number;
  wandaTripInfo: IWandaTripInfo;
};

const DownloadPdfTripDetailsCard: React.FC<prop> = ({
  trip,
  tripNo,
  wandaTripInfo,
}) => {
  const tripCostTotal =
    (trip?.levelOfServiceCost ?? 0) +
    (trip?.transportationCost ?? 0) +
    (trip?.vehicleTypeCost ?? 0);
  return (
    <View style={styles.card}>
      <View style={[styles.row, styles.boldText14, styles.legCostsAlign]}>
        <Text>Trip {tripNo}</Text>
        <Text>${tripCostTotal.toFixed(2)}</Text>
      </View>

      <View style={styles.tripDetailsContainer}>
        <View
          style={[styles.row, styles.normalText14, styles.overallCostAlign]}
        >
          <Text>Transportation</Text>
          <Text>${trip?.transportationCost?.toFixed(2)}</Text>
        </View>
        <View
          style={[styles.row, styles.normalText14, styles.overallCostAlign]}
        >
          <Text>{trip?.levelOfService}</Text>
          <Text>${trip?.levelOfServiceCost?.toFixed(2)}</Text>
        </View>
        {trip?.vehicleTypeCost !== 0 && (
          <View
            style={[styles.row, styles.normalText14, styles.overallCostAlign]}
          >
            <Text>WAV Upgrade</Text>
            <Text> ${trip?.vehicleTypeCost?.toFixed(2)}</Text>
          </View>
        )}
        <View style={styles.solidDivider} />
        {(trip?.wandaSubscriptionPlan !== "Basic" ||
          trip?.promoCodeDetail !== null) && (
          <>
            {trip?.wandaSubscriptionPlan !== "Basic" && (
              <View
                style={[
                  styles.row,
                  styles.normalText14,
                  styles.overallCostAlign,
                ]}
              >
                <Text>Wanda Plus Discount</Text>
                <Text style={styles.tripCostTextColor}>
                  {wandaTripInfo.wandaPlusDiscount * 100}% {"\u00A0\u00A0"}-$
                  {trip?.wandaPlusDiscountCost?.toFixed(2)}
                </Text>
              </View>
            )}
            {trip?.promoCodeDetail !== null && (
              <View
                style={[
                  styles.row,
                  styles.normalText14,
                  styles.overallCostAlign,
                ]}
              >
                <Text>Promo Code</Text>
                <Text style={styles.tripCostTextColor}>
                  {" "}
                  {trip?.promoCodeDetail?.discountType === "Percentage"
                    ? `${trip.promoCodeDetail?.discountValue}%`
                    : null}
                  {"\u00A0\u00A0"}
                  {`-$${trip.promoCodeDetail?.discountedAmount?.toFixed(2)}`}
                </Text>
              </View>
            )}

            <View style={styles.solidDivider} />
          </>
        )}
        <View
          style={[styles.row, styles.normalText16, styles.overallCostAlign]}
        >
          <Text>Charge amount</Text>
          <Text style={styles.boldText16}>${trip?.tripCost?.toFixed(2)}</Text>
        </View>
      </View>
    </View>
  );
};

export default DownloadPdfTripDetailsCard;
